import { Image, Modal } from "components/common";
import styles from "./index.module.less";
import { renderQuillHtml } from "configs/utils";

const ViewImageDetailModal = ({ selectedItem, setSelectedItem }) => {
  return (
    <Modal
      open={!!selectedItem}
      onCancel={() => setSelectedItem(null)}
      footer={null}
      title={
        <div className={styles.imagePreviewModal}>
          <div className={styles.modalTitle}>
            {selectedItem?.imageTitle || "Image Preview"}
          </div>
        </div>
      }
      width={900}
      centered
      bodyStyle={{ padding: "24px" }}
    >
      <div className={styles.imagePreviewModal}>
        <div className={styles.modalBody}>
          {/* Two-column grid layout */}
          <div className={styles.modalGrid}>
            {/* Left Column - Image */}
            <div className={styles.imageColumn}>
              {(selectedItem?.src || selectedItem?.url) && (
                <div className={styles.imageContainer}>
                  <Image
                    src={selectedItem?.src || selectedItem?.url}
                    alt={selectedItem?.imageTitle || "Preview Image"}
                    height="100%"
                    width="100%"
                    className={styles.previewImage}
                    preview={false}
                  />
                </div>
              )}
            </div>

            {/* Right Column - Information */}
            <div className={styles.infoColumn}>
              <div className={styles.infoContent}>
                {/* Source URL */}
                {selectedItem?.src && (
                  <div className={styles.infoItem}>
                    <div className={styles.label}>
                      <span className={styles.labelText}>Source:</span>
                    </div>
                    <div className={styles.value}>
                      <a
                        href={selectedItem?.src}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.link}
                      >
                        {selectedItem?.src}
                      </a>
                    </div>
                  </div>
                )}

                {/* Site URL */}
                {selectedItem?.siteURL && (
                  <div className={styles.infoItem}>
                    <div className={styles.label}>
                      <span className={styles.labelText}>Site URL:</span>
                    </div>
                    <div className={styles.value}>
                      <a
                        href={selectedItem?.siteURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={styles.link}
                      >
                        {selectedItem?.siteURL}
                      </a>
                    </div>
                  </div>
                )}

                {/* Description */}
                {selectedItem?.imageDescription && (
                  <div className={styles.infoItem}>
                    <div className={styles.label}>
                      <span className={styles.labelText}>Description:</span>
                    </div>
                    <div className={styles.value}>
                      {renderQuillHtml(selectedItem?.imageDescription)}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default ViewImageDetailModal;
